




import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

const menuLogout = [
		{
			title: "OO_LANG_LOGOUT",
			icon: "fa-power-off",
			link: "/logout"
		}
	],
	menuUser = [
		{
			title: "OO_LANG_EDIT",
			icon: "fa-pen",
			link: "/account/edit"
		},
		{
			title: "OO_LANG_PASS_EDIT",
			icon: "fa-lock",
			link: "/account/edit/pass"
		}
	],
	menuAdmin = [
		{
			title: "SX_LANG_SECTOR_ADD",
			icon: "fa-plus",
			link: "/sectors/add"
		},
		{
			title: "SX_LANG_COMPANY_ADD",
			icon: "fa-plus",
			link: "/companies/add"
		}
		//{
		//	title: "SX_LANG_USERS_FIND",
		//	icon: "fa-users",
		//	link: "/users/find"
		//}
	];

@Component
export default class WAccountMenu extends BaseComponent {
	get isAdmin() {
		return app.services.users.isAdmin();
	}
	get userMenu() {
		let menu = [menuUser];

		if (this.isAdmin) {
			menu.push(menuAdmin);
		}

		menu.push(menuLogout);

		return menu;
	}
}
